export enum TemplateLanguages {
  EN = 'en-EN',
  ES = 'es-ES',
  CA = 'ca-CA',
  EU = 'eu-EU',
  EUES = 'euses-EUSES',
}
